import React from "react";

// Props for the warning message
interface WarningMessageProps {
  message: string | null; // Warning message to display, or null to hide
}

// Component to render validation or error warnings
const WarningMessage: React.FC<WarningMessageProps> = ({ message }) => {
  if (!message) return null; // Hide if no message
  return (
    <div className="warning-message" data-testid="warning-message">
      <span>{message}</span>
    </div>
  );
};

export default WarningMessage;
